import React from 'react';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useSmac } from 'Shared/utils/hooks/use-smac';
import { useUpdateUserProfile } from 'Shared/utils/hooks/use-update-user-profile';

// Components
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpRadioGroup, WpRadioInput } from 'Wpds/components/radio';
import LoggedOutWrapper from 'Shared/route_layouts/LoggedOutWrapper';

// Styles
import './CalendarIntegration2023InvitedProfile.scss';

const CalendarIntegration2023InvitedProfile = () => {
  const { isAdvancingForward, profile, handleAdvanceOnboardingState } = useOnboardingState();
  const { user, isPiUser } = useCurrentUser();
  const { updateUserInfo } = useUpdateUserProfile();
  const { hasClassicAccess } = useSmac();

  const name = profile.fullName;
  const role = profile.role || 'manager';
  const pi2UseCase: boolean = isPiUser && !hasClassicAccess;
  const existingUserCreatedByPI: boolean = pi2UseCase && user.last_name !== 'CreatedByPerform';

  const handleSubmit = values => {
    const fullName = pi2UseCase ? `${values.first_name_input} ${values.last_name_input}` : values.name_input;

    if (!existingUserCreatedByPI) {
      // Update first and last name on PI side[User & SurveyUser] and SalesForce
      updateUserInfo(values.first_name_input, values.last_name_input);
    }

    handleAdvanceOnboardingState({
      onboardingState: {
        profile: {
          fullName: fullName,
          role: values.role_input,
        },
      },
      didSkip: false,
    });
  };

  const baseClassName = 'CalendarIntegration2023InvitedProfile';

  return (
    <LoggedOutWrapper>
      <h3 className={`${baseClassName}__title`}>Welcome to PI Perform!</h3>
      <WpForm onSubmit={handleSubmit}>
        <WpFormLayout direction="vertical">
          {!pi2UseCase && (
            <WpTextField
              id="name_input"
              type="text"
              label="Your full name"
              placeholder="full name"
              value={name}
              required
              showRequiredIndicator={false}
            />
          )}

          {pi2UseCase && (
            <>
              <WpTextField
                id="first_name_input"
                type="text"
                label="First name"
                placeholder="First name"
                value={existingUserCreatedByPI ? user.first_name : ''}
                required
                disabled={existingUserCreatedByPI}
                showRequiredIndicator={false}
              />
              <WpTextField
                id="last_name_input"
                type="text"
                label="Last name"
                placeholder="Last name"
                value={existingUserCreatedByPI ? user.last_name : ''}
                required
                disabled={existingUserCreatedByPI}
                showRequiredIndicator={false}
              />
            </>
          )}
          {!pi2UseCase && (
            <WpRadioGroup
              id="role_input"
              label="At work I am..."
              required
              direction="horizontal"
              defaultValue={role}
              showRequiredIndicator={false}
            >
              <WpRadioInput id="manager" label="a manager" value="manager" />
              <WpRadioInput id="full_member" label="An individual Contributor" value="full_member" />
            </WpRadioGroup>
          )}
        </WpFormLayout>
        <div className={`${baseClassName}__footer`}>
          <WpButtonGroup>
            <WpButton btnType="submit" qaTest="about-you-next" block size="lg" loading={isAdvancingForward}>
              Next
            </WpButton>
          </WpButtonGroup>
        </div>
      </WpForm>
    </LoggedOutWrapper>
  );
};

export default CalendarIntegration2023InvitedProfile;
